module.exports = __webpack_public_path__ + "img/12.2eae5907.jpg";